import { useMutation } from "@tanstack/react-query";
import { useModal } from "../../../../hooks";
import { exportRmaListExcelApi } from "../../../../api/support/RMA";
import { BasicSearchType } from "../../../../types/common/basic";
import { downloadFile } from "../../../../util/FileDownload";
import { AxiosError } from "axios";
import moment from "moment";

const useExportRmaListExcel = () => {
  const { handleModal } = useModal();

  const { mutate } = useMutation({
    mutationFn: (data: BasicSearchType) => exportRmaListExcelApi(data),
    onSuccess: (res) => {
      if (res instanceof Blob) {
        downloadFile(
          res,
          `RMA_data_list_${moment(new Date()).format("YYYY_MM_DD")}.xlsx`
        );
      }
    },
    onError: (error: AxiosError) => {
      if (error?.response?.data instanceof Blob) {
        error.response.data.text().then((value) => {
          const obj = JSON.parse(value);
          handleModal({
            isOpen: true,
            contents: obj?.msg,
            type: "alert",
          });
        });
      }
    },
  });
  return { mutate };
};

export default useExportRmaListExcel;
